// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2KLMh","label":"Section_label__2xUYX","contentWrap":"Section_contentWrap__2fspb","footer":"Section_footer__AD-2b","footerInner":"Section_footerInner___DXVn"};